import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Pill } from "@/components/kit";
import { JOB_STAGES, JOB_LABELS, usd, fmtDate } from "@/lib/format";
import { MapPin, User, HardHat, Camera } from "lucide-react";

export default function Production() {
  const [jobs, setJobs] = useState([]);
  const nav = useNavigate();
  const load = () => api.get("/jobs").then((r) => setJobs(r.data));
  useEffect(() => { load(); }, []);

  const move = async (job, status) => { await api.put(`/jobs/${job.id}/status?status=${status}`); load(); };
  const byStage = (s) => jobs.filter((j) => j.status === s);

  return (
    <div>
      <PageHeader title="Production" subtitle="Every job auto-created from a signed contract — material order, work order & crew ready" />
      <div className="flex gap-4 overflow-x-auto mb-scroll pb-4">
        {JOB_STAGES.map((s) => (
          <div key={s} className="min-w-[280px] w-[280px] shrink-0" data-testid={`job-column-${s}`}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => { const id = e.dataTransfer.getData("job"); const j = jobs.find((x) => x.id === id); if (j && j.status !== s) move(j, s); }}>
            <div className="flex items-center justify-between mb-2 px-1">
              <span className="font-display font-bold uppercase text-sm text-navy">{JOB_LABELS[s]}</span>
              <span className="font-num text-xs bg-slate-200 text-slate-600 rounded-full px-2 py-0.5">{byStage(s).length}</span>
            </div>
            <div className="space-y-2">
              {byStage(s).map((j) => {
                const doneCt = j.milestones?.filter((m) => m.done).length || 0;
                return (
                  <div key={j.id} draggable onDragStart={(e) => e.dataTransfer.setData("job", j.id)}
                    data-testid={`job-card-${j.id}`} onClick={() => nav(`/production/job/${j.id}`)}
                    className="mb-card p-3 cursor-pointer hover:shadow-md hover:-translate-y-0.5 transition-all">
                    <div className="flex justify-between items-start">
                      <div className="font-semibold text-navy text-sm">{j.customer_name}</div>
                      {j.gp_pct < j.target_margin_pct && <Pill tone="danger">{j.gp_pct}% GP</Pill>}
                    </div>
                    <div className="text-xs text-slate-500 flex items-center gap-1 mt-1 truncate"><MapPin className="w-3 h-3 shrink-0" /> {j.address}</div>
                    <div className="flex justify-between items-center mt-2 text-xs">
                      <span className="flex items-center gap-1 text-slate-500"><HardHat className="w-3 h-3" /> {j.crew || "Unassigned"}</span>
                      <span className="font-num text-successg font-bold">{usd(j.contract_amount_cents)}</span>
                    </div>
                    <div className="flex items-center gap-1 mt-2">
                      {j.milestones?.map((m) => <div key={m.key} className={`h-1.5 flex-1 rounded-full ${m.done ? "bg-successg" : "bg-slate-200"}`} />)}
                    </div>
                    <div className="text-[10px] text-slate-400 mt-1 flex items-center gap-1"><Camera className="w-3 h-3" /> {j.photos?.length || 0} photos · {doneCt}/3 QC</div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
